import { OCCUPATION_CANDIDATES } from '../../define/consts/profile';
import { isCanUseProfessionalProffit, isCanUseProfessionalProffitMart, isClient, isClientPreStatus, isProfessional, } from '../auth';
import { arrayFirstWhere } from '../common/ArrayHelper';
import { getPosition } from '../profile';
const commonCheck = (information) => {
    const { department, firstName, firstNameKana, lastName, lastNameKana, phone1, phone2, phone3, } = information || {};
    return (lastName &&
        firstName &&
        lastNameKana &&
        firstNameKana &&
        phone1 &&
        phone2 &&
        phone3 &&
        department);
};
export const hasRequiredParam = (auth, profile) => {
    const { freeInformation, information, organization } = profile;
    if (isClient(auth)) {
        // 企業ユーザ向け
        const occupationOtherId = arrayFirstWhere(OCCUPATION_CANDIDATES, 'other', true).id;
        const position = getPosition(profile, true);
        const { occupation, occupationOther } = information || {};
        return (commonCheck(information) &&
            (organization || isClientPreStatus(profile)) &&
            occupation &&
            position &&
            ((occupation === occupationOtherId && occupationOther) ||
                occupation !== occupationOtherId));
    }
    if (isProfessional(auth)) {
        // コンサル向け
        const { department, sex, situation } = information || {};
        const position = getPosition(profile, false);
        const useProffit = isCanUseProfessionalProffit(profile);
        const useProffitMart = isCanUseProfessionalProffitMart(profile);
        const organizationCheck = useProffit || useProffitMart ? organization : true;
        return (commonCheck(information) &&
            sex &&
            organizationCheck &&
            situation &&
            department &&
            position);
    }
    const { careers, firstName, firstNameKana, lastName, lastNameKana, phone1, phone2, phone3, sex, situation, } = information || {};
    const { assignable, careerChange, desiredFeePerDay, desiredFeePerHour, minimumFeePerDay, minimumFeePerHour, onSite, unitTime, } = freeInformation || {};
    // フリーコンサル向け
    return (lastName &&
        firstName &&
        lastNameKana &&
        firstNameKana &&
        phone1 &&
        phone2 &&
        phone3 &&
        sex &&
        situation &&
        assignable &&
        unitTime &&
        onSite &&
        careerChange &&
        minimumFeePerHour &&
        minimumFeePerDay &&
        desiredFeePerHour &&
        desiredFeePerDay &&
        careers &&
        careers.length > 0);
};
export default hasRequiredParam;
